import createIcon from "../createIcon";
import React from "react";

export const ArrowRightIcon = createIcon({
  path: (
    <path
      d="M18.5791 13.4196C17.7991 14.1996 17.7991 15.4596 18.5791 16.2396L26.3391 23.9996L18.5791 31.7596C17.7991 32.5396 17.7991 33.7996 18.5791 34.5796C19.3591 35.3596 20.6191 35.3596 21.3991 34.5796L30.5791 25.3996C31.3591 24.6196 31.3591 23.3596 30.5791 22.5796L21.3991 13.3996C20.6391 12.6396 19.3591 12.6396 18.5791 13.4196Z"
      fill="currentColor"
    />
  )
});
